import * as React from 'react';
export const locationPinSvg = React.forwardRef(function locationPinSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.99 10.973C12.204 9.347 13 7.725 13 6.393 13 3.722 10.735 1.5 8 1.5S3 3.723 3 6.392c0 1.333.796 2.955 2.01 4.581C6.023 12.33 7.19 13.513 8 14.28c.81-.766 1.977-1.948 2.99-3.306Zm-2.33 4.742c1.633-1.503 5.84-5.643 5.84-9.323C14.5 2.862 11.53 0 8 0S1.5 2.862 1.5 6.392c0 3.68 4.207 7.82 5.84 9.323.189.174.425.285.66.285.235 0 .47-.11.66-.285Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
    }),
  );
});
locationPinSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var locationPin = {
  category: 'icon',
  colorable: true,
  name: 'locationPin',
  svg: locationPinSvg,
};
